import domready from '../utils/domready.js'

const triggerWidth = (63.75 * 16)	// 63.75rem := $gridSwitch from _settings.scss
const navigationChange = new CustomEvent('navigationChange')
let viewport

function updateFitNavClass() {
  window.fitNavigationViewport = window.innerWidth < triggerWidth ? 'mobile' : 'desktop'
}

function fireNavigationChangeEvent() {
  document.body.dispatchEvent(navigationChange)
}

function valueChange(value, comparisonValue) {
  if (value != comparisonValue) {
    fireNavigationChangeEvent()
    return viewport = value
  }
}

export default new Promise(function (resolve, reject) {
  domready(function () {
    window.addEventListener('orientationchange', function () {
      valueChange(window.fitNavigationViewport, viewport)
    })

    window.addEventListener('resize', function () {
      valueChange(window.fitNavigationViewport, viewport)
      updateFitNavClass()
    })

    updateFitNavClass()
    viewport = window.fitNavigationViewport
    resolve()
  })
})
